<app-ng-icon class="text-blue-600" name="heroCheck"></app-ng-icon>
<ng-content> </ng-content>
